import {take, call, put, select} from 'redux-saga/effects'
import {
  SENDING_ACCOUNTS_REQUEST,
  FETCH_ACCOUNTS_REQUEST,
  FETCH_ACCOUNTS_SUCCESS,
  FETCH_ACCOUNTS_FAILURE,
  SENDING_ACCOUNT_UPDATE,
  UPDATE_ACCOUNT_REQUEST,
  //UPDATE_ACCOUNT_SUCCESS,
  UPDATE_ACCOUNT_FAILURE,
  SENDING_ACCOUNT_DELETE,
  DELETE_ACCOUNT_REQUEST,
  //DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
  SENDING_ACCOUNT_UPDATE_PERMISSION,
  UPDATE_ACCOUNT_PERMISSION_REQUEST,
  UPDATE_ACCOUNT_PERMISSION_FAILURE,
  SENDING_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE
} from '../actions/constants'
import {ROLE_HASH} from '../constants/defaultValues'
import account from '../api/account'
import {putNotify} from './utils'

const getTokenFromState = (state) => state.user.currentUser.token;
const getSystemIDFromState = (state) => state.system.currentSystem.ID;

function* fetchAccounts({token, systemID}) {
  yield put({type: SENDING_ACCOUNTS_REQUEST, sending: true})
  try {
    return yield call(account.fetchAccounts, token, systemID)
  } catch (error) {
    yield put({type: FETCH_ACCOUNTS_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_ACCOUNTS_REQUEST, sending: false})
  }
}

export function* watchFetchAccounts() {
  while (true) {
    yield take(FETCH_ACCOUNTS_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(fetchAccounts, {token, systemID})
    const arr = yield call(putNotify, {response})
    const accounts = Array.isArray(arr)
      ? arr
      : []
    yield put({type: FETCH_ACCOUNTS_SUCCESS, accounts: accounts});
  }
}

function* updateAccount({token, systemID, updateAccountState}) {
  yield put({type: SENDING_ACCOUNT_UPDATE, sending: true})
  try {
    return yield call(account.updateAccount, token, systemID, updateAccountState)
  } catch (error) {
    yield put({type: UPDATE_ACCOUNT_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_ACCOUNT_UPDATE, sending: false})
  }
}

export function* watchUpdateAccountRequest() {
  while (true) {
    const {updateAccountState} = yield take(UPDATE_ACCOUNT_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(updateAccount, {token, systemID, updateAccountState})
    yield call(putNotify, {response})
    yield put({type: FETCH_ACCOUNTS_REQUEST});
  }
}

function* updateAccountPermission({token, systemID, updatePermissionState}) {
  yield put({type: SENDING_ACCOUNT_UPDATE_PERMISSION, sending: true})
  try {
    return yield call(account.updateAccountPermission, token, systemID, updatePermissionState)
  } catch (error) {
    yield put({type: UPDATE_ACCOUNT_PERMISSION_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_ACCOUNT_UPDATE_PERMISSION, sending: false})
  }
}

export function* watchUpdateAccountPermissionRequest() {
  while (true) {
    const {accountState, updatePermissionState} = yield take(UPDATE_ACCOUNT_PERMISSION_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(updateAccountPermission, {token, systemID, updatePermissionState})
    const notify = `Cài đặt quyền ${ROLE_HASH[updatePermissionState.Role]} cho tài khoản [${accountState.UserName}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_ACCOUNTS_REQUEST});
  }
}

function* deleteAccount({token, systemID, deleteAccountState}) {
  yield put({type: SENDING_ACCOUNT_DELETE, sending: true})
  try {
    return yield call(account.deleteAccount, token, systemID, deleteAccountState)
  } catch (error) {
    yield put({type: DELETE_ACCOUNT_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_ACCOUNT_DELETE, sending: false})
  }
}

export function* watchDeleteAccountRequest() {
  while (true) {
    const {deleteAccountState} = yield take(DELETE_ACCOUNT_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(deleteAccount, {token, systemID, deleteAccountState})
    const notify = `Xoá tài khoản [${deleteAccountState.UserName}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_ACCOUNTS_REQUEST});
  }
}

function* fetchPermissions({token, systemID, accountIDState}) {
  yield put({type: SENDING_PERMISSIONS_REQUEST, sending: true})
  try {
    return yield call(account.fetchPermissions, token, systemID, accountIDState)
  } catch (error) {
    yield put({type: FETCH_PERMISSIONS_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_PERMISSIONS_REQUEST, sending: false})
  }
}

export function* watchFetchPermissions() {
  while (true) {
    const {accountIDState} = yield take(FETCH_PERMISSIONS_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(fetchPermissions, {token, systemID, accountIDState})
    const arr = yield call(putNotify, {response})
    const permissions = arr
      ? arr
      : []
    yield put({type: FETCH_PERMISSIONS_SUCCESS, permissions: permissions});
  }
}



// WEBPACK FOOTER //
// ./src/sagas/account.js